import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

interface IConfig {
  shouldHideNameFilter?: boolean
}

const defaultConfig = {}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'timoney_bk':
        return {
          ...defaultConfig,
          shouldHideNameFilter: true,
        }
      default:
        return defaultConfig
    }
  }, [brand])
}
